'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002493 from "./presto.-Two-Factor-Auth-View$$anon$93.js";
import * as $j_presto$002etypes$0024$0024anon$00244 from "./presto.types$$anon$4.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dId$0024 from "./presto.types$-Credential-Id$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsername$0024 from "./presto.types$-Credential-Username$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$92() {
  this.bJf = null;
  this.bJ7 = null;
  this.bJ8 = false;
  this.bJg = null;
  this.bJh = false;
  this.bJk = null;
  this.bJd = null;
  this.bJe = false;
  this.bJ9 = null;
  this.bJa = false;
  this.bJb = null;
  this.bJc = false;
  this.bJi = false;
  this.bJj = false;
  this.bJf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bJk = "Credential";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$92 as $c_Lpresto_TwoFactorAuthView$$anon$92 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$92.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$92;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$92() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$92 as $h_Lpresto_TwoFactorAuthView$$anon$92 };
$h_Lpresto_TwoFactorAuthView$$anon$92.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bJf;
});
$p.L = (function() {
  if ((!this.bJ8)) {
    this.bJ7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bJ8 = true;
  }
  return this.bJ7;
});
$p.O = (function() {
  if ((!this.bJh)) {
    this.bJg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bJh = true;
  }
  return this.bJg;
});
$p.E = (function() {
  return this.bJk;
});
$p.t = (function() {
  if ((!this.bJe)) {
    this.bJd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("username", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("inherited", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("created", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("expires", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bJe = true;
  }
  return this.bJd;
});
$p.M = (function() {
  if ((!this.bJa)) {
    this.bJ9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dId$0024.$m_Lpresto_types$CredentialId$().gH(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().cx(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().gl(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dUsername$0024.$m_Lpresto_types$CredentialUsername$().gI(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().ep(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().Z())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.bJa = true;
  }
  return this.bJ9;
});
$p.Q = (function() {
  if ((!this.bJc)) {
    this.bJb = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002493.$c_Lpresto_TwoFactorAuthView$$anon$93();
    this.bJc = true;
  }
  return this.bJb;
});
$p.w = (function() {
  if ((!this.bJj)) {
    this.bJi = false;
    this.bJj = true;
  }
  return this.bJi;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee1017) => ((p) => \u03b4scrutinee1017.gj(p)))($j_presto$002etypes$0024$0024anon$00244.$m_Lpresto_types$Credential$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$92 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$92, "presto.TwoFactorAuthView$$anon$92", ({
  Tw: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$92 as $d_Lpresto_TwoFactorAuthView$$anon$92 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$92.js.map
